import { useQuery } from "@tanstack/react-query";
import {
  OrderInterface,
  ProductOrderInterface,
} from "../../../interfaces/orderInterface";
import orderApi from "../../../services/orderApi";

export type ProductOrderCalc = Pick<ProductOrderInterface, "quantity"> & {
  productId: string;
};

export type UseProductOrderCalculation = Pick<
  OrderInterface,
  "shippingCost" | "applyShippingCost"
> & {
  dealerId: string;
  products: ProductOrderCalc[];
  applyPromotion: boolean;
  specialDiscount: number;
  orderId?: string;
  enabled?: boolean;
};

export const useProductOrderCalculationQuery = (
  params: UseProductOrderCalculation,
) => {
  const {
    dealerId,
    products,
    applyPromotion,
    specialDiscount: _specialDiscount,
    orderId,
    applyShippingCost,
    shippingCost,
    enabled,
  } = params;
  const specialDiscount = !_specialDiscount ? 0 : _specialDiscount;
  return useQuery({
    queryKey: [
      "calculate-order",
      dealerId,
      products.map((p) => `${p.productId}-${p.quantity}`),
      applyPromotion,
      specialDiscount,
      orderId,
      applyShippingCost,
      shippingCost?._id,
    ],
    queryFn: async () => {
      const res = await orderApi.calculatedOrder({
        dealerId,
        products,
        applyPromotion,
        specialDiscount,
        applyShippingCost,
        shippingCost,
        orderId,
      });
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
    enabled: enabled,
  });
};
